import { styled } from '@mui/material';
import { Clear } from '@ori-ui/icons';
import { colors } from '../theme/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const Icon = styled(Clear)({
  fontSize: 20,
  color: colors.defaultColors.main,
  margin: '0 -2px 0 -2px',
  cursor: 'pointer',
  '&:hover': {
    color: colors.defaultColors.light
  }
});
export default function ChipDeleteIcon() {
  return _jsx(Icon, {
    className: "MuiOriChipDeleteButton"
  });
}